export const constants = {
  minimumStayParagraph: `All non-holiday weekends in July and August have a 3 night
            minimum stay. Canada Day weekend (July 2 - 5) has a 4 night minimum stay.
            Civic Holiday weekend (July 30 - August 2) has a 5 night
            minimum stay. Labor Day weekend (Sept. 3 - 6) has a 3 night minimum stay.`,
  // "Bookings that include the Friday or Saturday of Labor Day weekend (Sept. 4, 5) have a 3-night minimum stay.",
  // We do accept shorter stays if we have gaps between existing reservations. Feel free to submit a request for a shorter weekend stay and we will let you know if we have a site available.

  depositRates: {
    2026: {
      peak: {
        start: "2026-06-12",
        end: "2026-09-06",
        rates: {
          Unserviced: 54,
          "Regular Serviced": 66,
          "Premium Serviced": 77,
          "50 Amp": 80,
          Cabin: 112,
        },
      },

      value: {
        start: "2026-05-01",
        end: "2026-10-12",
        rates: {
          Unserviced: 44,
          "Regular Serviced": 54,
          "Premium Serviced": 64,
          "50 Amp": 67,
          Cabin: 91,
        },
      },
    },

    2027: {
      peak: {
        start: "2027-06-11",
        end: "2027-09-05",
        rates: {
          Unserviced: 55,
          "Regular Serviced": 66,
          "Premium Serviced": 77,
          "50 Amp": 80,
          Cabin: 112,
        },
      },

      value: {
        start: "2027-05-01",
        end: "2027-10-11",
        rates: {
          Unserviced: 44,
          "Regular Serviced": 54,
          "Premium Serviced": 64,
          "50 Amp": 67,
          Cabin: 91,
        },
      },
    },
  },
  bookingDates: {
    2026: {
      open: "2026-05-01",
      close: "2026-10-12",
    },

    2027: {
      open: "2027-05-01",
      close: "2027-10-11",
    },
  },
  seasonalRates: {
    spring: 1200,
    fall: 1000,
    springFall: 2000,
  },
  seasonalDates: {
    2027: {
      springStart: "2027-04-30",
      springEnd: "2027-06-18",
      fallStart: "2027-09-06",
      fallEnd: "2027-10-11",
    },
  },
};
